// extracted by mini-css-extract-plugin
export default {"list":"TodoList_list__-JGjN","list--item":"TodoList_list--item__m-PU8","completed":"TodoList_completed__qZ+kp","btn":"TodoList_btn__uHoA4","dark":"TodoList_dark__mEg+M"};